import { ExpenseType } from "../types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all expenses
export const getExpenses = async () => {
  return axios
    .get(ServiceEndpoints.EXPENSES)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new expense
export const createExpense = async (data: ExpenseType) => {
  return axios
    .post(ServiceEndpoints.EXPENSES, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an existing expense
export const updateExpense = async (id: string, data: ExpenseType) => {
  const { ...supplierData } = data;

  return axios
    .put(`${ServiceEndpoints.EXPENSES}/${id}`, supplierData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a expense by its ID
export const getExpenseById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.EXPENSES}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a expense
export const deleteExpense = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.EXPENSES}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
